'use strict';

var Card = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card',
		is_autorun: true,
		is_preloaded: true,
		first_autorun_duration: 5000,
		autorun_duration: 5500,
		transition_duration: 200
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
			this.adaFix();
		}
	},

	adaFix: function adaFix() {
		this._element.setAttribute('role', 'region');
		this._element.setAttribute('aria-label', 'carousel');
	},

	build: function build() {
		var _this2 = this;

		var opts = this.options,
		    fcls = '.' + opts.cls,
		    _this = document.id(this);

		this.is_first = true;
		this.pagination = null;

		this._btnprevious = _this.getElement(fcls + '_btnprevious') || new Element('div');
		this._btnnext = _this.getElement(fcls + '_btnnext') || new Element('div');
		this._stage = _this.getElement(fcls + '_stage');
		this._pagination = _this.getElement(fcls + '_pagination') || new Element('div', { 'class': opts.cls + '_pagination' }).inject(this._stage, 'after');
		this._items = _this.getElements(fcls + '_item');

		this.stage = new Card.Stage(this._stage, this._items, this);

		if (this._items.length == 1) {
			this.set_image(0);

			this._btnprevious.dispose();
			this._btnnext.dispose();
		} else {
			this.pagination = new Card.Pagination(this._pagination, this);

			this._btnprevious.addEvent('click', function () {
				this.is_clicked = true;
				this.clear_periodical();
				this.set_previous_image();
			}.bind(this));

			this._btnnext.addEvent('click', function () {
				this.is_clicked = true;
				this.clear_periodical();
				this.set_next_image();
			}.bind(this));

			this.set_image(0);

			this.periodical = null;

			if (opts.is_autorun) {
				// will have to inject a play / pause button if it is auto play
				var playOrPause = new Element('button', {
					html: 'Pause',
					'class': 'card-play-pause no-style'
				});

				// should be place after w_card_btnprevious
				var previousBtn = this._element.querySelector('.w_card_btnprevious');
				if (!previousBtn) return;
				playOrPause.inject(previousBtn, 'after');
				playOrPause.addEventListener('click', function () {
					if (_this2.periodical) _this2.clear_periodical();else _this2.autoPlay();
				});
				this.playOrPause = playOrPause;
				this.autoPlay();
			}
		}
	},

	autoPlay: function autoPlay() {
		var opts = this.options;
		this.set_direction('next');
		this.playOrPause.innerHTML = 'Pause';
		(function () {
			this.set_next_image();

			this.clear_periodical();
			this.periodical = this.set_next_image.periodical(this.options.autorun_duration, this);
		}).bind(this).delay(opts.first_autorun_duration);
	},

	clear_periodical: function clear_periodical() {
		if (this.options.is_autorun && this.periodical) {
			clearInterval(this.periodical);
			this.periodical = null;
			this.playOrPause.innerHTML = 'Play';
		}

		return this;
	},

	get_direction: function get_direction() {
		return this.direction;
	},

	set_direction: function set_direction(direction) {
		this.direction = direction;
		return this;
	},

	set_image: function set_image(index) {
		if (!this.is_animating) {
			this.stage.set_image_by_index(index);

			if (this.pagination) {
				this.pagination.set_current_page_index(index);
			}
		}
	},

	set_next_image: function set_next_image() {
		this.set_direction('next');
		this.set_image(this.pagination.retrieve_next());
	},

	set_previous_image: function set_previous_image() {
		this.set_direction('previous');
		this.set_image(this.pagination.retrieve_previous());
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Pagination = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_pagination'
	},

	initialize: function initialize(_element, card, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.card = card;
		this.build();
	},

	build: function build() {
		var _this = this._element;

		this.items = [];
		this.current_page_index = 0;

		this.card._items.length.times(function (i) {
			var item = new Element('a', {
				'href': '#',
				'html': '',
				events: {
					click: function (e) {
						if (e && e.stop) e.stop();

						if (i == this.get_current_page_index()) return;

						var direction = this.get_current_page_index() < i ? 'next' : 'previous';

						this.card.is_clicked = true;
						this.card.clear_periodical().set_direction(direction).set_image(i);
					}.bind(this)
				}
			}).inject(_this);

			this.items.push(item);
		}.bind(this));
	},

	get_current_page_index: function get_current_page_index() {
		return this.current_page_index;
	},

	retrieve_next: function retrieve_next() {
		var count = this.items.length;

		if (this.current_page_index == count - 1) {
			return 0;
		}

		return this.current_page_index + 1;
	},

	retrieve_previous: function retrieve_previous() {
		var count = this.items.length;

		if (this.current_page_index == 0) {
			return count - 1;
		}

		return this.current_page_index - 1;
	},

	set_current_page_index: function set_current_page_index(index) {
		this.items[this.current_page_index].removeClass('selected');
		this.current_page_index = index;
		this.items[index].addClass('selected');
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Stage = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_stage'
	},

	initialize: function initialize(_element, _items, card, options) {
		if (!_element) return;

		this.setOptions(options);

		this._element = _element;
		this._items = _items;
		this.card = card;
		this.build();
	},

	build: function build() {
		var opts = this.options,
		    fcls = '.' + opts.cls,
		    _this = document.id(this);

		this.active_item = null;
		this.items = [];
		this.times_accessed = 0;

		this._canvas = _this.getElement(fcls + '_canvas');

		this._items.each(function (_item, i) {
			var item_options = {};

			if (i == 0) {
				item_options = {
					preloads: false
				};
			}

			this.items.push(new Card.Item(_item, this, this.card, item_options));
		}.bind(this));

		if (this.card.options.is_preloaded) {
			this.preload();
		}
	},

	preload: function preload() {
		var images = [];

		this.items.each(function (itm) {
			images.push(itm.get_src());
		}.bind(this));

		Asset.images(images, {
			onProgress: function (c, i) {
				this.items[i].is_loaded = true;
				this.items[i].set_image();
			}.bind(this),

			onComplete: function () {
				this.fireEvent('on_preload');
			}.bind(this)
		});
	},

	get_container: function get_container() {
		return this._canvas;
	},

	set_image: function set_image(item) {
		if (this.active_item) {
			this.active_item.close();
		}

		this.active_item = item;
		item.open();
		item.set_image();
		this.times_accessed++;
	},

	set_image_by_index: function set_image_by_index(index) {
		this.set_image(this.items[index]);
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Item = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_item',
		preloads: true
	},

	initialize: function initialize(_element, stage, card, options) {
		//console.log(_element); return;
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.stage = stage;
		this.card = card;
		this.build();
	},

	build: function build() {

		var _this = document.id(this);

		this.has_image = false;

		var _img = _this.getElement('img') || _this;

		this.src = _img.getAttribute('data-image');
		this.url = _this.getAttribute('data-url') || false;
		this.targeted = _this.getAttribute('data-target') || false;

		if (this.url) {
			this.enable_card_click();
		}

		this.is_loaded = false;

		this.width = _this.getSize().x;

		var dur = this.card.options.transition_duration || 0;
		this._element.set('tween', { link: 'cancel', duration: dur });
	},

	enable_card_click: function enable_card_click() {
		this._element.setStyle('cursor', 'pointer');
		this._element.addEvent('click', function () {
			this.go_to_url();
		}.bind(this));
	},

	go_to_url: function go_to_url() {
		if (this.targeted) {
			window.open(this.url, this.targeted);
			return;
		}

		location.href = this.url;
	},

	close: function close() {
		var _this = this._element;

		_this.removeClass('active');

		var __hide = function __hide() {
			_this.setStyle('left', '150%');
			_this.get('tween').removeEvent('complete', __hide);
		};

		_this.set('tween', {
			onComplete: __hide
		});

		_this.tween('opacity', 0);

		this.fireEvent('close');
	},

	preload: function preload() {
		if (this.options.preloads) {
			Asset.image(this.src);
		}
	},

	load_image: function load_image() {
		(function () {
			Asset.image(this.src, {
				onLoad: function () {
					this.is_loaded = true;
					this.set_image();
				}.bind(this)
			});
		}).delay(300, this);
	},

	open: function open() {
		var _this = this._element;

		_this.addClass('active');

		_this.setStyles({
			'opacity': 0.1,
			'left': 0
		});

		_this.tween('opacity', 1);

		this.fireEvent('open');
	},

	get_src: function get_src() {
		return this.src;
	},

	set_image: function set_image() {
		if (!this.is_loaded && !this.card.options.is_preloaded) {
			this.load_image();
		} else {
			if (!this.has_image) {
				this.has_image = true;
				var sanitized = this.src.trim();
				// document.id(this).setStyle('background-image', 'url('+sanitized+')');
				var _this = document.id(this);
				var _img = _this.getElement('img') || _this;

				_img.setProperty('src', sanitized);
			}
		}
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

var SalesData = new Class({
	Implements: [Options, Events],

	options: {
		data: null,
		cls: 'w_sales_data',
		use_cookies: true,
		colors: {
			10: '#b19f00',
			11: '#018f9b',
			12: '#b4224a',
			13: '#484a67',
			14: '#ff5a00'
		},
		shorten_pricerange: false
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		var self = this;

		this.beds_filter_applied = false;
		this.first_load = true;
		this.is_loaded = false;

		if (this.options.use_cookies) {
			window.addEvent('beforeunload', function (e) {
				// set the cookie only if the chart is initialized.
				if (self.is_loaded) {
					self.write_cookies();
				}
			});

			this.read_cookies();
		} else {
			this.cookies = {};
		}

		this._beds_filter = this._element.getElement('.beds_filter');

		this._veil = this._element.getElement('.veil');
		this._data_display = this._element.getElement('.data_display');
		this._chart = this._element.getElement('.chart');
		this._list = this._element.getElement('.list');

		this._chart.show = function () {
			if (self._element.hasClass('_list_view')) return;

			self._chart.removeClass('_hidden');
		};

		this._chart.hide = function () {
			self._chart.addClass('_hidden');
		};

		this._controllers = this._element.getElement('.data_controllers');

		this.new_currency = true;

		this.rpc = this.add_type_select();

		this.add_currency_select();
		this.add_period_select();
		this.add_beds_select();
		// this.add_listings_select();

		this.get_data();
	},

	add_type_select: function add_type_select() {
		var self = this;

		this._type_select = this._element.getElement('.type_select');

		if (!this._type_select) return;

		var _selected;

		if (this.cookies.type) {
			this._type_select.getElements('option').some(function (_el) {
				if (_el.getAttribute('data-type') == self.cookies.type) {
					_selected = _el;
					_el.fireEvent('select');
					return true;
				}
			});
		}

		this._type_select.addEvents({
			'change': function change(_el) {
				var data_rpc = _el.getAttribute('data-rpc');

				if (data_rpc) {
					self.rpc = data_rpc;
				}

				var _selected = self._type_select.getElement('._selected') || self._type_select.getElement('option:selected');

				if (_selected) {
					self._element.type = _selected.getAttribute('data-type');
				}

				self.get_data();
			}
		});

		_selected = _selected || this._type_select.getElement('._selected') || this._type_select.getElement('option:selected') || this._type_select.getElements('option')[0];

		this._element.type = _selected.getAttribute('data-type');

		return _selected.getAttribute('data-rpc');
	},

	add_currency_select: function add_currency_select() {
		var self = this;

		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		if (this.cookies.currency) {
			this._currency_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.currency) {
					_el.fireEvent('select');
					self.currency = _el.get('value');
					return true;
				}
			});
		}

		if (!this.currency) {
			var _selected = this._currency_select.getElement('option[selected]') || this._currency_select.getElement('option');
			this.currency = _selected.get('value');
		}

		this._currency_select.addEvent('change', function () {
			self.currency = self._currency_select.getElement(':selected').get('value');

			self._element.currency = {
				'id': self.currency,
				'symbol': self.data.currency_symbol
			};

			self.new_currency = true;
			self.get_data();
		});
	},

	add_period_select: function add_period_select() {
		var self = this;

		this._period_select = this._element.getElement('.w_styled_select.period select');

		if (this.cookies.period) {
			this._period_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.period) {
					_el.fireEvent('select');
					self.start_date = _el.get('value');
					return true;
				}
			});
		}

		if (!this.start_date) {
			var _selected = this._period_select.getElement('option[selected]') || this._period_select.getElement('option');
			this.start_date = _selected.get('value');
		}

		this._period_select.addEvent('change', function () {
			self.update_section_title();

			self.start_date = self._period_select.getElement(':selected').get('value');
			self.get_data();
		});

		self.update_section_title();
	},

	add_listings_select: function add_listings_select() {
		var self = this;

		this._listings_select = this._element.getElement('.w_styled_select._listings select');

		if (this.cookies.listings) {
			this._listings_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.listings) {
					_el.fireEvent('select');
					self.listings_type = _el.get('value');
					return true;
				}
			});
		}

		if (!this.listings_type) {
			var _selected = this._listings_select.getElement('option[selected]') || this._listings_select.getElement('option');
			this.listings_type = _selected.get('value');
		}

		this._listings_select.addEvent('change', function () {
			self.update_section_title();

			self.listings_type = self._listings_select.getElement(':selected').get('value');
			self.get_data();
		});

		self.update_section_title();
	},

	add_beds_select: function add_beds_select() {
		var self = this;

		//this._bed_select = this._element.getElement('.w_multiselect._beds select');

		this.beds_multiselect = new Multiselect(this._element.getElement('.w_multiselect._beds'), {
			text_input: false,
			close_button: false,
			equality: true,
			add_tiles: false,
			onClick: function onClick(e, _el) {

				Cookie.write('salesDataBedsClicked', true);

				if (!_el.hasClass('_active')) return;

				_el.toggleClass('_hover');
				self.filter_bedrooms(_el.getAttribute('data-id'));

				if (self._list.instance) {
					self._list.instance.update();
				}

				self.first_load = false;
			}
		});

		this.beds_multiselect.update_monitor();
	},

	update_section_title: function update_section_title() {
		var _section_title = this._element.getElement('.header h2 span');

		if (_section_title) {
			var _selected_period = this._period_select.getElement('option:selected') || this._period_select.getParent().getElement('.selected');
			_section_title.set('text', _selected_period.get('text').capitalize());
		}
	},

	get_data: function get_data() {
		var self = this;
		this._veil.show();

		if (this.remote) {
			this.remote.cancel();
		}

		if (this.options.data) {
			this.data = this.get_data();
			this.proceed_rpc();

			return;
		}

		var rpc = this.rpc + '&start_date=' + this.start_date + '&currency=' + this.currency + (this.options.shorten_pricerange ? '&price_format=short' : '');

		this.remote = new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				self.data = this.get_data();

				self.proceed_rpc();
			},
			onError: this.display_error_message.bind(this)
		});
	},

	proceed_rpc: function proceed_rpc() {
		var id = this._currency_select.getElement(':selected').get('value').toLowerCase();

		this._element.currency = {
			'id': id,
			'symbol': this.data.currency_symbol
		};

		if (this.data.list.length < 1) {
			this.display_error_message();
			return;
		}

		//to count all sales in data
		// var count = 0;

		// Object.each(this.data.list, function(el){
		// 	Object.each(el, function(e){
		// 			count += e.length;
		// 	});
		// });

		// console.log(count);

		this.set_beds();
		this.set_price_range();
		//this.set_year_range();

		if (this._controllers) this._controllers.addClass('_ready');

		this.create_chart();

		if (this._list.instance) {
			var data = this.data.list[this._element.selected_graph_id] || [];

			this._list.instance.update(data);
		}
	},

	// set_year_range: function(){
	// 	this._year_range = this._year_range || this._element.getElement('#year_slider');

	// 	if(!this._year_range) return;

	// 	this.data.year_select = {
	// 		'keys': [2000,2001,2002,2003,2004,2005,2006,2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015],
	// 		'values': ['2000','2001','2002','2003','2004','2005','2006','2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015']
	// 	}

	// 	var self = this;
	// 	var values = this.data.year_select.values;

	// 	Object.each(values, function(el, i){
	// 		values[i] = Core.get_html_text(el);
	// 	});

	// 	// values[values.length - 1] += '+';

	// 	// var title = (this._element.type == 'onmarket'? 'Listing Prices: ' : 'Closing Prices: ');
	// 	var title = 'Year: ';

	// 	this._year_range.empty();
	// 	this._year_range.getParent().getElements('input').dispose();

	// 	this.year_range = new Rangeslider(this._year_range, {
	// 		title: title,
	// 		config: this.data.year_select,
	// 		min: this.cookies.year_range? this.cookies.year_range[0] : null,
	// 		max: this.cookies.year_range? this.cookies.year_range[1] : null,
	// 		onComplete: function(min, max){
	// 			console.log('test');
	// 			self.get_min_and_max_year();


	// 			//self.create_chart();

	// 			// if(self._list.update){
	// 			// 	self._list.update();
	// 			// }
	// 			// if(self._list.instance){
	// 			// 	self._list.instance.update();
	// 			// }
	// 		}
	// 	});

	// 	this.get_min_and_max_year();
	// 	this.cookies.year_range = [];
	// },

	set_price_range: function set_price_range() {
		this._price_range = this._price_range || this._element.getElement('.w_rangeslider');

		if (!this._price_range) return;

		var self = this;
		var values = this.data.price_select.values;

		Object.each(values, function (el, i) {
			values[i] = Core.get_html_text(el);
		});

		values[values.length - 1] += '+';

		// var title = (this._element.type == 'onmarket'? 'Listing Prices: ' : 'Closing Prices: ');
		var title = 'Price: ';

		if (this.new_currency) {
			this._price_range.empty();
			this._price_range.getParent().getElements('input').dispose();

			this.price_range = new Rangeslider(this._price_range, {
				title: title,
				config: this.data.price_select,
				min: this.cookies.price_range ? this.cookies.price_range[0] : null,
				max: this.cookies.price_range ? this.cookies.price_range[1] : null,
				onComplete: function onComplete(min, max) {
					self.get_min_and_max_price();
					self.create_chart();

					// if(self._list.update){
					// 	self._list.update();
					// }
					if (self._list.instance) {
						self._list.instance.update();
					}
				}
			});

			this.new_currency = false;
		} else {
			var _rs_title = this.price_range._element.getElement('.w_rangeslider_title');

			if (_rs_title) {
				_rs_title.set('html', title);
			}
		}

		this.get_min_and_max_price();
		this.cookies.price_range = [];
	},

	display_error_message: function display_error_message() {
		this._chart.hide();
		this._veil.hide();

		this._msg = this._msg || this._element.getElement('.error');

		this._msg.show();
	},

	set_beds: function set_beds() {
		var self = this;

		this.active_beds = {
			10: false,
			11: false,
			12: false,
			13: false,
			14: false
		};

		if (this.cookies.beds) {
			Object.each(this.cookies.beds, function (el, i) {
				if (el) {
					self._beds_filter.getElement('li.beds_' + i).addClass('_selected');
				} else {
					self._beds_filter.getElement('li.beds_' + i).removeClass('_selected');
				}
			});

			this.cookies.beds = null;
			this.first_load = false;
			this.beds_multiselect.update_monitor();
		} else if (!this.beds_filter_applied && !this.first_load) {
			this._beds_filter.getElements('li').addClass('_selected');
		}

		this.beds_filter_applied = true;

		Object.each(this.data.list, function (el) {
			Object.each(el, function (e, i) {
				self.active_beds[i] = self.active_beds[i] || e && e.length > 0;
			});
		});

		Object.each(this.active_beds, function (el, i) {
			var _bed = self._beds_filter.getElement('li.beds_' + i);
			if (!_bed) return;

			if (el) {
				_bed.addClass('_active');
			} else {
				_bed.removeClass('_active');
			}
		});
	},

	create_chart: function create_chart() {
		var self = this;

		var options = {
			data: this.data,
			currency_id: this._currency_select.getElement(':selected').get('value'),
			style: this._element.hasClass('_light') ? 'light' : 'dark',
			colors: this.options.colors,
			min: this.min_price,
			max: this.max_price,

			onReady: function onReady() {
				self.cookies.region = JSONMOO.decode(Cookie.read('salesDataRegion'), false);
				if (self.cookies.region) {
					this.charts.some(function (el) {
						if (el.chart.id == self.cookies.region) {
							el._lvt.fireEvent('click');
							return true;
						}
					});
				}

				self._veil.hide();
				self.is_loaded = true;
			},

			onSelectRegion: function onSelectRegion(id) {
				self.create_list(id);
			}
		};

		this.display = new SalesData.Display(this._data_display, options);

		if (!this.first_load) {
			this._beds_filter.getElements('li').each(function (_el) {
				if (!_el.hasClass('_selected')) {
					self.filter_bedrooms(_el.getAttribute('data-id'));
				}
			});
		}
	},

	filter_bedrooms: function filter_bedrooms(id) {
		var self = this;

		if (this.display) {
			this.display.charts.each(function (el) {
				el.chart.series.each(function (e) {
					if (self.first_load) {
						if (e.name == id) {
							e.show();
							self.active_beds[id] = true;
						} else {
							e.hide();
							self.active_beds[e.name] = false;
						}
					} else {
						if (e.name != id) return;

						if (e.visible) {
							e.hide();
							self.active_beds[id] = false;
						} else {
							e.show();
							self.active_beds[id] = true;
						}
					}
				});
			});
		}

		this.get_min_and_max_price();

		if (this.display) {
			this.display.charts.each(function (el) {
				el.chart.yAxis[0].setExtremes(self.min_price, self.max_price);
			});

			this.display.set_info();
		}
	},

	get_min_and_max_price: function get_min_and_max_price() {
		var self = this;
		var min = 1; //since we use logarithmic chart, we can't use 0
		var max = 1;

		Object.each(this.data.list, function (el) {
			Object.each(el, function (e) {
				e.each(function (listing) {
					var id = listing.bedroom_id > 14 ? 14 : listing.bedroom_id;

					if (self.active_beds[id] && listing.y <= self.price_range.get_max() && listing.y >= self.price_range.get_min()) {
						min = min == 1 || listing.y < min ? listing.y : min;
						max = max == 1 || listing.y > max ? listing.y : max;
					}
				});
			});
		});

		this.min_price = Math.max(min, this.price_range.get_min());
		this.max_price = Math.min(max, this.price_range.get_max());
	},

	// get_min_and_max_year: function(){
	// 	var self = this;
	// 	var min = 1; //since we use logarithmic chart, we can't use 0
	// 	var max = 1;

	// 	Object.each(this.data.list, function(el){
	// 		Object.each(el, function(e){
	// 			e.each(function(listing){
	// 				var id = (listing.bedroom_id > 14? 14 : listing.bedroom_id);
	// 				var date = new Date(listing.sale_date);
	// 				var year = date.getFullYear();

	// 				if(self.active_beds[id] && year <= self.year_range.get_max() && year >= self.year_range.get_min()){
	// 					min = ((min == 1 || year < min)? year : min);
	// 					max = ((max == 1 || year > max)? year : max);
	// 				}
	// 			});
	// 		});
	// 	});

	// 	this.min_year = Math.max(min, this.year_range.get_min());
	// 	this.max_year = Math.min(max, this.year_range.get_max());
	// },

	read_cookies: function read_cookies() {
		this.cookies = {
			type: Cookie.read('salesDataType'),
			currency: Cookie.read('salesDataCurrency'),
			period: Cookie.read('salesDataPeriod'),
			beds: JSONMOO.decode(Cookie.read('salesDataBeds'), false),
			price_range: JSONMOO.decode(Cookie.read('salesDataPriceRange'), false),
			region: JSONMOO.decode(Cookie.read('salesDataRegion'), false)
		};
	},

	write_cookies: function write_cookies() {
		var self = this;
		var sales_data_type = this._element.type;
		var sales_data_currency = this.currency;
		var sales_data_period = this.start_date;
		var sales_data_beds = {};

		this._element.getElements('.beds_filter li').each(function (_el) {
			sales_data_beds[_el.getAttribute('data-id')] = self.active_beds[_el.getAttribute('data-id')];
		});

		var sales_data_price_range = [];

		this._element.getElements('.price_filter input').each(function (_el) {
			sales_data_price_range.push(_el.get('value'));
		});

		var sales_data_region = this._element.selected_graph_id;

		Cookie.write('salesDataType', sales_data_type);
		Cookie.write('salesDataCurrency', sales_data_currency);
		Cookie.write('salesDataPeriod', sales_data_period);
		Cookie.write('salesDataBeds', JSONMOO.encode(sales_data_beds));
		Cookie.write('salesDataPriceRange', JSONMOO.encode(sales_data_price_range));
		Cookie.write('salesDataRegion', sales_data_region);
		Cookie.write('salesDataBedsClicked', '');
	}
});

SalesData.Display = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this.stats = new SalesData.Stats(this._element.getElement('.stats'));
		this._chart = this._element.getElement('.chart');
		this._list = this._element.getElement('.list');

		this._widget = this._element.getParent('.w_sales_data');
		this._widget.set_info = this.set_info.bind(this);

		this._chart.empty();
		this._chart.show();

		this.currency_id = this.options.currency_id;

		this.regions = this.data.regions;

		this.create_multigraph();

		this.set_info();

		this.adjust_titles();

		this.fireEvent('ready');
	},

	get_number_of_regions: function get_number_of_regions() {
		var number_of_graphs = 0;

		Object.each(this.data.list, function (el) {
			var data_length = 0;

			Object.each(el, function (e) {
				data_length += e.length;
			});

			if (data_length > 0) {
				number_of_graphs++;
			}
		});

		return number_of_graphs;
	},

	create_multigraph: function create_multigraph() {
		var self = this;
		var pl = this._chart.getStyle('padding-left').toInt() || 0;
		var pr = this._chart.getStyle('padding-right').toInt() || 0;
		var cont_width = this._chart.getSize().x - pl - pr;

		var add_width = 75;
		var deducted_value = 5; // to reduce the width of the subgraph to have spaces.
		var number_of_graphs = this.get_number_of_regions();

		var width = Math.round((cont_width - add_width) / number_of_graphs, 0);

		add_width = cont_width - width * number_of_graphs;

		var ordered_regions = [{
			id: 2,
			name: this.regions[2]
		}, {
			id: 1,
			name: this.regions[1]
		}, {
			id: 11,
			name: this.regions[11]
		}, {
			id: 3,
			name: this.regions[3]
		}, {
			id: 13,
			name: this.regions[13]
		}, {
			id: 4,
			name: this.regions[4]
		}];

		var wide_graph = true;
		this.charts = [];

		ordered_regions.each(function (el) {
			if (!self.data.list[el.id] || Object.keys(self.data.list[el.id]).length < 1) return;

			var cls = '.subgraph' + (wide_graph ? '._first' : '');

			var _subgraph = new Element(cls);
			_subgraph.inject(self._chart);
			_subgraph.setStyle('width', (wide_graph ? width + add_width : width) - deducted_value);

			_subgraph.is_wide = wide_graph;
			_subgraph.region_id = el.id;

			el._graph = _subgraph;

			var margin_left = wide_graph ? add_width : 0;

			new Element('.subgraph_tick').inject(_subgraph).setStyles({ 'margin-left': margin_left });

			var _title = new Element('.subgraph_title', { 'html': el.name + '<span class="tail">&nbsp;</span>' });

			_title.inject(_subgraph).setStyles({ 'margin-left': margin_left });

			self.stats._element.setStyle('margin-left', add_width);

			wide_graph = false;
		});

		var i = 0;

		//yes, yes, looping 2 times .... because of ie8
		ordered_regions.each(function (el) {
			if (!self.data.list[el.id] || Object.keys(self.data.list[el.id]).length < 1) return;

			var chart_options = {
				data: self.data.list[el.id],
				y_axis_labels_width: i == 0 ? add_width : 0,
				backgroundColor: self._element.getStyle('backgroundColor'),
				colors: self.options.colors,
				currency_symbol: self.data.currency_symbol,
				currency_id: self.options.currency_id,
				x: self.data.x,
				y: self.data.y,
				max: self.options.max,
				min: self.options.min,
				stats: self.stats,
				style: self.options.style,
				name: el.name,
				id: el.id
			};

			var chart = new SalesData.Chart(el._graph, chart_options);
			self.charts.push(chart);

			i++;
		});
	},

	adjust_titles: function adjust_titles() {
		var _titles = this._chart.getElements('.subgraph_title');
		var min_height = 0;

		_titles.each(function (_el) {
			var height = _el.getSize().y;

			if (min_height == 0 || height < min_height) {
				min_height = height;
			}
		});

		_titles.each(function (_el) {
			var padding = _el.getStyle('padding-top').toInt() - (_el.getSize().y - min_height) / 2;

			_el.setStyles({
				'padding-bottom': padding,
				'padding-top': padding
			});
		});
	},

	set_info: function set_info(chart) {
		var chart;

		if (!chart && this._widget.selected_graph_id) {
			this.charts.some(function (el) {
				if (el.chart.id == this._widget.selected_graph_id) {
					chart = el;
					return true;
				}
			}.bind(this));
		}

		this.stats.set_info(chart ? [chart] : this.charts);
	}
});

SalesData.Stats = new Class({
	initialize: function initialize(element) {
		if (!element) return;

		this._element = element;
		this._widget = this._element.getParent('.w_sales_data');
	},

	set_info: function set_info(charts) {
		var sales = 0;
		var median_sales_count = 0;
		var ppsqft = 0;
		var med_price;

		var med_prices_array = [];

		var currency_symbol = this._widget.currency.symbol;
		var currency_id = this._widget.currency.id;

		charts.each(function (el) {
			el.chart.series.each(function (e) {
				if (!e.visible) return;

				e.data.each(function (ee, i) {
					// if(ee.config[4]){
					// 	median_sales_count++;
					// 	ppsqft += (ee.config[4] || 0).toFloat();
					// }

					var config4 = ee.series.options.data[ee.index][4];

					if (config4) {
						median_sales_count++;
						ppsqft += (config4 || 0).toFloat();
					}

					sales++;
					med_prices_array.push(ee.y);
				});
			});
		});

		var info;

		if (sales == 0) {
			info = '<div class="err">There are no recent sales that match the criteria</div>';
		} else {
			med_prices_array = med_prices_array.sort(function (a, b) {
				return a - b;
			});

			if (med_prices_array.length % 2 == 0) {
				med_price = ((med_prices_array[med_prices_array.length / 2] + med_prices_array[med_prices_array.length / 2 - 1]) / 2).round(0);
			} else {
				med_price = med_prices_array[(med_prices_array.length / 2).floor()].round(0);
			}

			if (currency_id == 'xau' || currency_id == 'rub') {
				ppsqft = ppsqft == 0 ? 'N/A' : Core.add_commas((ppsqft / median_sales_count).round(currency_id == 'xau' ? 2 : 0)) + ' <span class="cs">' + currency_symbol + '</span>';
				med_price = Core.add_commas(med_price) + ' <span class="cs">' + currency_symbol + '</span>';
			} else {
				ppsqft = ppsqft == 0 ? 'N/A' : '<span class="cs">' + currency_symbol + '</span>' + Core.add_commas((ppsqft / median_sales_count).round(ppsqft / median_sales_count > 100 ? 0 : 2));
				med_price = '<span class="cs">' + currency_symbol + '</span>' + Core.add_commas(med_price);
			}

			info = '<ul class="clearfix ' + (Core.get_html_text(currency_symbol).length > 1 ? '_letters' : '') + '">' + '<li class="_first"><span class="big">' + sales + '</span>' + (this._widget.type == 'onmarket' ? '<span>Total Listings</span>' : '<span>Total Sales</span>') + '</li>' + '<li><span class="big">' + ppsqft + '</span><span>Median Price / Ft<sup>2</sup></span></li>' + '<li><span class="big">' + med_price + '</span><span>Median Price</span></li>' + '</ul>';
		}

		this._element.set('html', info);
		this.adjust_text_size();
	},

	adjust_text_size: function adjust_text_size() {
		//prices in some currencies are too long, so we have to change size of the text to fit it

		var _big_texts = this._element.getElements('.big');

		if (_big_texts.length == 0) return;

		if (_big_texts[2].get('text').length >= 14) {
			_big_texts.each(function (_el) {
				_el.addClass('_smaller');
			});
		} else {
			_big_texts.each(function (_el) {
				_el.removeClass('_smaller');
			});
		}
	}
});

SalesData.Chart = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this._widget = this._element.getParent('.w_sales_data');

		this.create_chart();
		this.add_mouse_events();
		this.create_list_view_toggle();
	},

	create_chart: function create_chart() {
		var self = this;
		var series = this.create_series();

		var _chart_cont = this._chart_cont = new Element('.chart_cont').inject(this._element, 'top');

		var max = this.options.max;
		var min = this.options.min > 0 ? this.options.min : 1;

		this.chart = new Highcharts.Chart({
			chart: {
				renderTo: _chart_cont,
				type: 'scatter',
				plotBackgroundColor: this.options.backgroundColor,
				backgroundColor: this.options.backgroundColor,
				marginBottom: 0,
				marginLeft: this.options.y_axis_labels_width,
				marginRight: 0,
				animation: false,
				spacingTop: 20,
				events: {
					tooltipHide: function tooltipHide() {
						if (self._tooltip) {
							self._tooltip.hide();
						}
					},
					tooltipMove: function tooltipMove(e) {
						self.position_tooltip(self._element, e[0], e[1]);
					},
					click: function click() {
						if (!Core.is_touch_supported()) {
							self._lvt.fireEvent('click');
						}
					}
				}
			},

			xAxis: {
				categories: self.regions_by_name,

				labels: {
					enabled: false
				},

				min: 0.5,
				max: 5.5,

				minPadding: 0.2,
				maxPadding: 0.2,

				title: {
					text: null
				},

				tickLength: 0
			},

			yAxis: {
				type: 'logarithmic',
				min: min,
				max: max,
				gridLineColor: '#aaa',
				gridLineDashStyle: 'dash',
				showFirstLabel: false,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: this._element.is_wide ? this.options.y.label : null,
					style: {
						color: '#999'
					},
					margin: 10
				},

				labels: {
					enabled: this._element.is_wide,
					style: {
						color: '#999'
					},
					formatter: function formatter() {
						var cs = Core.get_html_text(self.options.currency_symbol || '&#36;');
						if (cs.length > 1) cs = '';

						if (this.value < 100) {
							return cs + Highcharts.numberFormat(this.value, 2);
						} else {
							var s;

							if (this.value % 1000000000 == 0) {
								s = this.value / 1000000000 + 'G';
							} else if (this.value % 1000000 == 0) {
								s = this.value / 1000000 + 'M';
							} else if (this.value % 1000 == 0) {
								s = this.value / 1000 + 'k';
							} else {
								s = this.value;
							}

							return cs + s;
						}
					}
				}
			},

			series: series,

			tooltip: {
				useHTML: true,
				formatter: function formatter() {
					if (!this.point.series.visible) return;

					var index;
					if (this.point.dataGroup) {
						index = this.point.dataGroup.start;
					} else {
						index = this.point.index;
					}

					var content = this.point.series.options.data[index][2];

					self.display_tooltip(content, this.point.series.color);
					self.position_tooltip(self._element, this.point.plotX, this.point.plotY);

					return false;
				}
			},

			plotOptions: {
				column: {
					stacking: 'normal'
				},

				scatter: {
					marker: {
						radius: 7
					},
					events: {
						click: function click(e) {
							var stop = false;
							var index;

							// to display the tooltip on the first click
							if (Core.is_touch_supported()) {
								if (self.active_series != e.point) {
									stop = true;
								}

								self.active_series = e.point;

								if (stop) return;
							}

							if (e.point.dataGroup) {
								index = e.point.dataGroup.start;
							} else {
								index = e.point.index;
							}

							var url = e.point.series.options.data[index][3];

							if (url) {
								Cookie.write('salesDataSeriesClicked', true);

								window.location = url;
							}

							//NCR-5306 if user click the dot while on the market insight landing page.
							if ($(document.body).get('id') === 'min') {
								document.fireEvent('miSaveActiveGraph', ['salesData']);
							}

							self.seriesClicked = true;
						},
						mouseOut: function mouseOut() {
							if (self._tooltip) {
								self._tooltip.hide();
							}
						}
					}
				},

				series: {
					cursor: 'pointer'
				}
			},

			credits: {
				enabled: false
			},

			title: {
				text: null
			},

			legend: {
				enabled: false
			}
		});

		this.chart.id = this.options.id;
	},

	// get_prices_intervals: function(){ //for better distribution of dots
	// 	var prices = {};

	// 	var max = this.options.max;
	// 	var min = (this.options.min > 0? this.options.min : 1);

	// 	var range = max - min;
	// 	var step = range / 20;

	// 	while(range > 0){
	// 		prices[range] = [];
	// 		range -= step;
	// 	}

	// 	return prices;
	// },

	get_x: function get_x(number) {
		var x = number % 5 + 1;

		//todo: we need better distribution of dots on x axis

		return x;
	},

	create_series: function create_series() {
		var self = this;
		var series = [];
		// var prices = this.get_prices_intervals(); //for better distribution of dots

		Object.each(this.data, function (el, beds_id) {
			var graph_data = [];
			var url = [];

			el.each(function (e, i) {
				if (e.y > self.options.max || e.y < self.options.min) return;

				var x = self.get_x(beds_id.toInt() + i + (e.sqft || 0));

				graph_data.push([x, e.y, e.tooltip, e.url_sold || e.url, e.ppsqft]);

				url.push(e.url_sold);
			});

			series.push({
				data: graph_data,
				color: self.options.colors[beds_id],
				marker: { symbol: 'circle' },
				name: beds_id
			});
		});

		return series;
	},

	add_mouse_events: function add_mouse_events() {
		//if(Core.is_touch_supported()) return;

		var self = this;
		var _rect = this._element.getElements('svg>rect');
		var color = this.options.style == 'light' ? '#ccc' : '#777';
		var stats = self.options.stats;

		if (_rect) {
			_rect = _rect[1] || _rect[0];
		}

		this._element.addEvents({
			'touchstart': function touchstart() {
				var _tooltips = document.getElements('.chart_tooltip._sales_data');
				if (_tooltips) {
					_tooltips.each(function (_el) {
						_el.hide();
					});
				}
			},

			'mouseenter': function mouseenter() {
				if (Core.is_touch_supported()) {
					var _current_active_subgraph = document.getElement('.subgraph._hover');
					if (_current_active_subgraph) {
						_current_active_subgraph.fireEvent('mouseleave');
					}
				}

				self._element.addClass('_hover');

				if (_rect) {
					_rect.setProperty('fill', color);
					_rect.setProperty('height', _rect.getProperty('height').toInt() + 20);
					_rect.setProperty('y', 0);
				}

				stats.gen_info = stats._element.get('html');
				stats.set_info([self]);
			},

			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');

				if (_rect) {
					_rect.setProperty('fill', self.options.backgroundColor);
					_rect.setProperty('height', _rect.getProperty('height').toInt() - 20);
				}

				if (self.hidden) {
					self.hidden = false;
					return;
				}

				stats._element.set('html', stats.gen_info);
			},

			'click': function click(e) {
				self.hidden = true;

				if (e.target != self._lvt) {
					self._lvt.fireEvent('click');
				}
			}
		});
	},

	display_tooltip: function display_tooltip(tooltip, color) {
		this._tooltip = this._tooltip || new Element('.chart_tooltip._sales_data', {
			'html': '<div class="info"></div><div class="pointer">&nbsp;</div>'
		}).inject(document.body);

		tooltip += '<br/><br/>Click dot for full ' + (this._widget.type == 'onmarket' ? 'listing details' : 'sales summary');

		this._tooltip.getElement('.info').set('html', tooltip);
		this._tooltip.setStyle('borderColor', color);
		this._tooltip.getElement('.pointer').setStyle('borderTopColor', color);
		this._tooltip.show();
	},

	position_tooltip: function position_tooltip(_cont, x, y) {
		// To center the tooltip, we need to use the position of the subgraph_title because this has the same width of the graph.
		var pos_x = _cont.getElement('.subgraph_title').getPosition().x + x - this._tooltip.getSize().x / 2;
		var pos_y = _cont.getPosition().y + y - this._tooltip.getSize().y / 2 - 35; // - this._tooltip.getElement('.pointer').getSize().y - 10;

		this._tooltip.setStyles({
			'top': pos_y,
			'left': pos_x
		});
	},

	create_list_view_toggle: function create_list_view_toggle() {
		var self = this;
		var _list_view_toggle = this._lvt = new Element('.list_view_toggle', { 'html': 'Go to List View' });

		_list_view_toggle.inject(this._element, 'top');
		_list_view_toggle.setStyles({
			'margin-left': this.options.y_axis_labels_width
		});

		_list_view_toggle.addEvents({
			'click': function click() {
				if (self.seriesClicked) {
					return;
				}

				self._widget.selected_graph_id = self.chart.id;

				self.options.stats.gen_info = self.options.stats._element.get('html');
				self.options.stats.set_info([self]);
				self.show_list();
			}
		});
	},

	show_list: function show_list() {
		if (this.list) {
			this.list.show();
		} else {
			this.list = this.list || new SalesData.List(this._element.getParent().getNext('.list'), this.options);
		}
	}
});

SalesData.List = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this._widget = this._element.getParent('.w_sales_data');
		this._chart = this._element.getPrevious('.chart');
		this.show();
	},

	set_content: function set_content() {
		var content = '<span class="region_name">' + this.options.name + '</span>';

		this._element.set('html', content);
		this.create_table();
		this.add_back_link();
	},

	create_table: function create_table() {
		var _table = this._element.getElement('.w_divtable');

		if (_table) {
			_table.dispose();
		}

		this._table = new Element('.w_divtable' + (this._widget.type == 'onmarket' ? '._onmarket' : ''));

		this._thead = new Element('.thead', {
			'html': '<div class="tr">' + '<div class="th building_name"><div class="th_content">Building / Address</div></div>' + '<div class="th size"><div class="th_content">Size</div></div>' + '<div class="th closing_price"><div class="th_content">' + (this._widget.type == 'onmarket' ? 'Price' : 'Closing Price') + '</div></div>' + '<div class="th closing_date"><div class="th_content">' + (this._widget.type == 'onmarket' ? '' : 'Closing Date') + '</div></div>' + '</div>'
		});

		this._tbody = new Element('.tbody');

		this._table.adopt([this._thead, this._tbody]);

		this._element.adopt(this._table);

		this.add_rows();
	},

	add_rows: function add_rows() {
		var self = this;
		var opts = this.options;

		this.sorted_data = this.sorted_data || (this._widget.type == 'sold' ? this.sort_by_date() : this.sort_by_price());

		var selected_bedrooms = [];

		var cookie_beds = Cookie.read('salesDataBeds');

		if (Cookie.read('salesDataBedsClicked')) {
			this._widget.getElements('.beds_filter ._active._selected').each(function (_el) {
				selected_bedrooms.push(_el.getAttribute('data-id').toInt());
			});
		} else if (cookie_beds) {
			cookie_beds = JSONMOO.decode(cookie_beds, false);

			Object.each(cookie_beds, function (el, i) {
				if (el == true) {
					selected_bedrooms.push(i.toInt());
				}
			});
		} else {
			this._widget.getElements('.beds_filter li').each(function (_el) {
				selected_bedrooms.push(_el.getAttribute('data-id').toInt());
			});
		}

		var extremes = this._widget.getElements('.price_filter input[type="hidden"]');

		var min = extremes[0] ? extremes[0].get('value') : opts.min;
		var max = extremes[1] ? extremes[1].get('value') : opts.max;

		this.sorted_data.each(function (el) {
			var id = el.bedroom_id.toInt() > 14 ? 14 : el.bedroom_id.toInt();

			if (el.y < min || el.y > max || !selected_bedrooms.contains(id)) return;

			var _tr = new Element('.tr');

			_tr.addEvents({
				'click': function click() {
					window.location = el.url_sold || el.url;

					//NCR-5306 if user click the dot while on the market insight landing page.
					if ($(document.body).get('id') === 'min') {
						document.fireEvent('miSaveActiveGraph', ['salesData']);
					}
				}
			});

			_tr.setStyle('border-left', '6px solid ' + opts.colors[id]);

			var name = (el.name || el.street_address).trim();

			var building = (name && name != '' ? '<span>' + (el.name || el.street_address) + ', </span>' : '') + '<span class="unit"> Apt ' + el.unit + '</span>' + (el.name ? '<br/>' + el.street_address : '');

			var size = '<span>' + (Number.from(el.bedroom) ? Number.from(el.bedroom) : el.bedroom) + (Number.from(el.bedroom) ? Number.from(el.bedroom) > 1 ? ' beds' : ' bed' : '') + '</span><br/>' + Number.from(el.bathroom) + (Number.from(el.bathroom) > 1 ? ' baths' : ' bath') + (el.sqft == 0 ? '' : ' | ' + el.sqft_format + ' / ft <sup>2</sup>');

			var closing_price = '<span>' + el.sale_price_format + '</span>' + (el.ppsqft == 0 ? '' : '<br/> Approx. ' + el.ppsqft_format + ' / ft <sup>2</sup>');
			var closing_date = '<span>' + (el.sale_date ? el.sale_date : '') + '</span>';

			new Element('.td.building_name', { 'html': '<div class="td_content">' + building + '</div>' }).inject(_tr);
			new Element('.td.size', { 'html': '<div class="td_content">' + size + '</div>' }).inject(_tr);
			new Element('.td.closing_price', { 'html': '<div class="td_content">' + closing_price + '</div>' }).inject(_tr);
			new Element('.td.closing_date', { 'html': '<div class="td_content">' + closing_date + '</div>' }).inject(_tr);

			_tr.inject(self._tbody);
		});

		new Divtable(this._table, {
			'zebra_order': 'odd'
		});

		// console.log(this._element.getSize().y, this._chart.getSize().y);

		if (this._element.getSize().y > this._chart.getSize().y) {
			this._thead.addClass('_table_scroll');

			new StyledScroll(this._tbody, {
				type: 'v',
				max_height: 315
			});
		}
	},

	update: function update(data) {
		if (data) {
			this.data = data;
			this.sorted_data = null;
		}

		this.create_table();
	},

	sort_by_price: function sort_by_price() {
		var sorted_list = [];

		Object.each(this.data, function (el) {
			el.each(function (e) {
				sorted_list.push(e);
			});
		});

		if (sorted_list.length > 1) {
			sorted_list = sorted_list.sort(function (a, b) {
				var price_a = a.sale_price.toInt();
				var price_b = b.sale_price.toInt();

				return price_a > price_b ? -1 : 1;
			});
		}

		return sorted_list;
	},

	sort_by_date: function sort_by_date() {
		var sorted_list = [];

		Object.each(this.data, function (el) {
			el.each(function (e) {
				sorted_list.push(e);
			});
		});

		if (sorted_list.length > 1) {
			sorted_list = sorted_list.sort(function (a, b) {
				var date_a = new Date(a.sale_date).set({ sec: 0, ms: 0 }).format("%s");
				var date_b = new Date(b.sale_date).set({ sec: 0, ms: 0 }).format("%s");

				return date_a > date_b ? -1 : 1;
			});
		}

		return sorted_list;
	},

	add_back_link: function add_back_link() {
		if (this._back_link) {
			this._back_link.inject(this._element, 'top');
			return;
		}

		var self = this;
		this._back_link = new Element('.back', { 'text': 'Back to Graph' });

		this._back_link.inject(this._element, 'top');

		this._back_link.addEvents({
			'click': function click() {
				self._widget.selected_graph_id = null;
				self.hide();
			}
		});
	},

	show: function show() {
		this.set_content();
		this._chart.hide();
		this._widget.addClass('_list_view');

		this._widget.set_info();
		this._element.instance = this;
	},

	hide: function hide() {
		this._widget.removeClass('_list_view');
		this._element.empty();
		this._chart.show();

		this._widget.set_info();
		this._element.instance = null;
		Cookie.write('salesDataRegion', null);
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

Page.Srt = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		var _graph = document.getElement('.recent_sales');

		if (_graph) {
			this.add_recent_sales(_graph);
		}
	},

	add_recent_sales: function add_recent_sales(_cont) {
		var _recent_sales = _cont;
		if (!_recent_sales) return;

		new SalesData();

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			var _price_filter = _recent_sales.getElement('.price_filter');

			if (_price_filter) {
				_price_filter.addClass('_no_slider');
			}
		}
	}
});
//# sourceMappingURL=srt.js.map
